<mat-card class="example-card">
  <mat-card-header class="titreFrm">
    <mat-card-title>{{ "paramétre compte".toUpperCase() }}</mat-card-title>
  </mat-card-header>
  <mat-card-content class="border">
    <div>
      <div *ngIf="exist; else attente"></div>
      <ng-template #attente>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-template>
    </div>

    <ng-template #frmCompte>
      <form class="example-form" #f="ngForm">
        <div class="btn">
          <div class="button-row">
            <button
              (click)="ajouter(f)"
              [disabled]="!exist"
              mat-raised-button
              class="colorGreen"
            >
              <mat-icon>{{ btn.icon }}</mat-icon
              >{{ btn.text }}
            </button>
          </div>
          <div class="button-row">
            <button
              (click)="close()"
              [disabled]="!exist"
              mat-raised-button
              class="colorRed"
            >
              <mat-icon>close</mat-icon>Fermer
            </button>
          </div>
        </div>

        <mat-form-field
          *ngIf="show"
          appearance="outline"
          class="example-full-width"
        >
          <mat-label>Nom d'utilisateur</mat-label>
          <input
            [disabled]="!(btn.text == 'Ajouter')"
            matInput
            name="username"
            #username="ngModel"
            [(ngModel)]="user.username"
            placeholder="Identifiant"
            required
          />
        </mat-form-field>
        <mat-form-field
          *ngIf="show"
          appearance="outline"
          class="example-full-width"
        >
          <mat-label>Email</mat-label>
          <input
            matInput
            type="email"
            pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
            name="email"
            #email=""
            [(ngModel)]="user.email"
            placeholder="Email"
            required
          />
        </mat-form-field>
        <mat-form-field
          *ngIf="showMotPasse"
          appearance="outline"
          class="example-full-width"
        >
          <mat-label>Mot de passe</mat-label>
          <input
            matInput
            type="password"
            name="passwordd"
            #passwordd="ngModel"
            [(ngModel)]="user.password"
            placeholder="Mot de passe"
            required
          />
        </mat-form-field>
        <mat-form-field
          *ngIf="showMotPasse"
          appearance="outline"
          class="example-full-width"
        >
          <mat-label>Confirmer</mat-label>
          <input
            type="password"
            matInput
            name="confirmpasswordd"
            #confirmpasswordd="ngModel"
            [(ngModel)]="user.confirmpassword"
            placeholder="Confirmer"
            required
          />
        </mat-form-field>
        <mat-form-field *ngIf="show" appearance="outline">
          <mat-label>Type Menue</mat-label>
          <mat-select
            name="menu"
            #menu="ngModel"
            [(ngModel)]="user.menu"
            placeholder="Type Menue"
            required
          >
            <mat-option *ngFor="let type of listeMenu" [value]="type.Menu_Code">
              {{ type.Menu_Code }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="show" appearance="outline">
          <mat-label>Salari&eacute;</mat-label>
          <mat-select
            placeholder="Salari&eacute;"
            name="tiers"
            [(ngModel)]="user.tiers"
          >
            <mat-option
              *ngFor="let Perso of listeCollaborateur"
              [(ngModel)]="Perso.Perso_Matricule"
            >
              {{ Perso.NomPrenom }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </ng-template>

    <mat-card class="example-card carClass">
      <mat-card-content>
        <app-avt-listes
          [multipleSelect]="false"
          #listeCompteComponen
          [showFilter]="true"
          [heightTable]="'400'"
          [dataSourceBrut]="[]"
          [displayedColumnsBrut]="columns"
          [listBtn]="listBtnCompte"
          (btnTable)="clickBtnHeat($event)"
        >
        </app-avt-listes>
      </mat-card-content>
    </mat-card>
  </mat-card-content>
</mat-card>
